module.exports = "/templates/customers.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/customers.html
// module id = 443
// module chunks = 0